import React, { useState } from 'react';
import { Button } from '@meitu/saas-ui';
import { Editor } from '@meitu/saas-editor-core';
import { type WatermarkLayer } from '@meitu/saas-editor-core/es/layers/watermark-layer';
import { getImgInfoAsync } from '@meitu/saas-editor-core/es/utils/file-kit';
import IconFont from '@meitu/xdesign-icon-font';
import ImageUpload, { ImageUploadProps } from '@/components/image-upload';
import { LOCAL_WATERMARK_CONFIRM, useWatermarkConfirm } from '@/components/watermark-confirm';
import { useLocaleStore } from '@/i18n';
import AddWatermark from '../add-watermark/index';
import './index.less';

interface ImgOnloadProp {
    width: number;
    height: number;
}

type UploadImgProps = {
    editor: Editor;
    recordId?: number;
    // @FIXME 类型改成 IUserInfoParams
    userInfo: any;
    jumpToLogin: () => Promise<string>;
    saveMyPicture: (data: any) => Promise<any>;
};

const UploadImg: React.FC<UploadImgProps> = React.memo((props) => {
    const { recordId, jumpToLogin, saveMyPicture, editor, userInfo } = props;
    const [data, setData] = useState<string>('');
    const { $t } = useLocaleStore();
    const { watermarkConfirm } = useWatermarkConfirm();

    const funcID = '18_107';

    const fn = async (url: string, imgInfo: ImgOnloadProp) => {
        await saveMyPicture({
            url,
            width: imgInfo.width,
            height: imgInfo.height,
            module: '1',
            ext: JSON.stringify({ elementType: 'common' }),
            source: '0',
        });
        setData(url);
    };
    const uploadImgProp: ImageUploadProps = {
        maxCount: 1,
        autoConvertWebp: true,
        convertType: 'image/png',
        children: (
            <div>
                <Button
                    type="primary"
                    data-blue
                    block
                    className="add-watermark-button"
                    onClick={async (e) => {
                        if (!userInfo) {
                            e.stopPropagation();
                            jumpToLogin();
                            return;
                        }
                        window._stat_track?.('tpbj_subfunction_click', {
                            record: recordId,
                            func: funcID,
                        });
                    }}
                >
                    <IconFont name="PlusBold" fontSize={14} />
                    {$t((v) => v.collapse.watermarkCollapse.uploadWatermark)}
                </Button>
            </div>
        ),
        beforeUpload(file: any) {
            editor.services.mask.show({
                loading: true,
                background: true,
            });
        },
        async onSuccess(url: string, options: ImgOnloadProp, uid: string) {
            const imgInfo = (await getImgInfoAsync(url)) as ImgOnloadProp;
            const local = localStorage.getItem(LOCAL_WATERMARK_CONFIRM);

            const watermarkLayer = editor.getInstance<WatermarkLayer>('WatermarkLayer').getWatermarkLayer();
            if (watermarkLayer && !local) {
                watermarkConfirm(
                    () => {
                        fn(url, imgInfo);
                    },
                    () => {
                        editor.services.mask.hide();
                    },
                );
            } else {
                fn(url, imgInfo);
            }
            window._stat_track?.('tpbj_subfunction_tick', {
                record: recordId,
                func_id: funcID,
            });
        },
        onError(msg: string, { file }: any) {
            editor.services.mask.hide();
        },
    };
    return (
        <>
            <ImageUpload {...uploadImgProp} tips={$t((v) => v.collapse.watermarkCollapse.limitImageSize)} />
            <AddWatermark url={data} setUrl={setData} editor={editor} />
        </>
    );
});

export default UploadImg;
